import React, { useState, useEffect } from "react";
import TableDiff from "./SubComponents/TableDiff";
import { useTableActions } from "./SubComponents/hooks/useTableActions";
import RecHeader from "./RecHeader";
import AddRecModal from "./AddAppModal"; // Updated import
import EditJobsModal from "./EditJobsModal"; // Add this import
import {
  recruitJobsApis,
  recruitJobApplicationApis,
} from "../../../Data/axios";
import { Button, Drawer } from "@mui/material";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";
import JobViewMoreModal from "./JobApplicationViewModal"; // Import the JobViewMoreModal component

export default function JobTableUI() {
  const [open, setOpen] = useState(false); //add job modal
  const [filtersOpen, setFiltersOpen] = useState(false);

  // States for API data
  const [jobTitles, setJobTitles] = useState([]);
  const [jobApplications, setJobApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [queries, setQueries] = useState({
    page: 1,
    per_page: 10,
  });

  // Fetch data on component mount
  const fetchData = async (params = {}) => {
    try {
      setLoading(true);
      const jobAppResponse = await recruitJobApplicationApis.getAll({
        page: params.page || queries.page,
        per_page: params.per_page || queries.per_page,
      });
      console.log("before formatting", jobAppResponse.data.data);
      // Format the data
      const formattedData = jobAppResponse.data.data.map((app) => ({
        ...app,
        job_name: app.job?.title || "",
        applied_at: app.applied_at ? app.applied_at.split("T")[0] : "",
        // end_date: app.end_date ? app.end_date.split("T")[0] : "",
        status: (() => {
          switch (app.status) {
            case 0:
              return "Applied";
            case 1:
              return "Interview";
            case 2:
              return "Hired";
            case 3:
              return "Rejected";
            default:
              return "--";
          }
        })(),
        // recruiter_empid: app.recruiter?.empid || "",
        // recruiter_name: app.recruiter?.name || "",
      }));

      //   console.log("Formatted Job Titles Data:", formattedData);
      setJobApplications(formattedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching skills:", error);
      setJobApplications([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [queries.page, queries.per_page]);

  const tableActions = useTableActions(recruitJobApplicationApis, fetchData);
  const {
    showEdit,
    editData,
    setShowEdit,
    setEditData,
    showViewMore,
    viewData,
    setShowViewMore,
    setViewData,
  } = tableActions;

  // Handle modal open/close
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle save job - refresh data after adding new job
  const handleSaveJob = async () => {
    try {
      // Refresh job titles data
      const jobTitlesResponse = await recruitJobsApis.getAllJobTitle();
      setJobTitles(jobTitlesResponse.data.rjobs.data);
    } catch (err) {
      console.error("Error refreshing data:", err);
    }
  };

  const handleFiltersOpen = () => {
    setFiltersOpen(true);
  };

  const handleFiltersClose = () => {
    setFiltersOpen(false);
  };

  //table settings
  const headers = [
    { key: "applicant_name", label: "Name", sortable: true },
    { key: "job_name", label: "Jobs", sortable: true },
    {
      key: "applicant_current_location",
      label: "Applicant Location",
      sortable: true,
    },
    { key: "applied_at", label: "Date", sortable: true },
    { key: "status", label: "Status", sortable: true },
  ];

  const handlePageChange = (newPage) => {
    setQueries({ ...queries, page: newPage });
  };

  const handlePerPageChange = (newPerPage) => {
    setQueries({ ...queries, per_page: newPerPage, page: 1 });
  };

  return (
    <div>
      <RecHeader onFiltersOpen={handleFiltersOpen} />
      <Box display="flex" justifyContent="flex-start">
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleOpen}
          sx={{
            bgcolor: "#4285F4",
            color: "white",
            "&:hover": {
              bgcolor: "#3367D6",
            },
            marginTop: "32px",
            marginLeft: "18px",
            paddingY: "8px",
            borderRadius: "4px",
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Add Job Application
        </Button>
      </Box>

      {/* <ReusableTableDiff
        headers={headers}
        data={jobTitles}
        rowKey="id"
        defaultSortKey="id"
        tableClassName="table-class"
        headerClassName="header-class"
        rowClassName="row-class"
        queries={{ page: 1, per_page: 10 }}
      /> */}

      <TableDiff
        headers={headers}
        data={jobApplications}
        rowKey="id"
        defaultSortKey=""
        tableActions={tableActions}
        tableApis={recruitJobApplicationApis}
        onTableUpdate={fetchData}
        onPageChange={handlePageChange}
        onPerPageChange={handlePerPageChange}
        queries={queries}
        type="jobs"
        tableClassName="jobs-table"
      />

      {/* Use the new AddRecModal component */}
      <AddRecModal
        open={open}
        handleClose={handleClose}
        handleSave={handleSaveJob}
        tableApis={recruitJobApplicationApis}
      />

      {/* Add Filters Drawer */}
      <Drawer
        anchor="right"
        open={filtersOpen}
        onClose={handleFiltersClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            padding: "24px",
            boxSizing: "border-box",
            backgroundColor: "#ffffff",
          },
        }}
      >
        <div className="p-6 bg-white">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-medium text-gray-800">Filters</h2>
            <button
              onClick={handleFiltersClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <div className="space-y-6">
            {/* Date Filter */}
            <div>
              <p className="text-gray-600 mb-3">Date Filter On</p>
              <div className="relative">
                <select className="w-full p-2.5 border border-gray-300 rounded text-gray-900 appearance-none bg-white focus:outline-none focus:border-blue-500">
                  <option>Start Date</option>
                  <option>End Date</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

            {/* Department */}
            <div>
              <p className="text-gray-600 mb-3">Department</p>
              <div className="relative">
                <select className="w-full p-2.5 border border-gray-300 rounded text-gray-900 appearance-none bg-white focus:outline-none focus:border-blue-500">
                  <option>All</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

            {/* Status */}
            <div>
              <p className="text-gray-600 mb-3">Status</p>
              <div className="relative">
                <select className="w-full p-2.5 border border-gray-300 rounded text-gray-900 appearance-none bg-white focus:outline-none focus:border-blue-500">
                  <option>All</option>
                  <option>Open</option>
                  <option>Closed</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Drawer>

      {/* Add the JobViewMoreModal component */}
      <JobViewMoreModal
        open={showViewMore}
        handleClose={() => setShowViewMore(false)}
        viewData={viewData}
      />

      {/* Add the EditJobsModal component */}
      <EditJobsModal
        open={showEdit}
        handleClose={() => setShowEdit(false)}
        handleSave={fetchData}
        tableApis={recruitJobApplicationApis}
        editData={editData}
      />
    </div>
  );
}
